import { SxGeneral } from "../../../../../../../utils/types/generals"

type SxStyles = SxGeneral<'arrow' | 'header' | 'evidenceContainer' | 'actions' | 'evidenceFooter' | 'titleEvidences' | 'evidence'>

export const useStyles = (): SxStyles => {
    return ({
        evidenceFooter: {

        },
        titleEvidences: {
            fontSize: '16px',
            color: 'c_grey.100',
            fontWeight: '600',
            marginBottom: '10px',
        },
        evidence: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        arrow: {
            marginLeft: -4,
        },
        evidenceContainer: {
            height: '100%',
            padding: 3,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
        actions: {
            width: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 1
        },
    })
}